import { TrendingDown, TrendingUp } from 'lucide-react';
import React from 'react'

const MetricCard = ({ icon, title, value, change, period }) => {
  const isPositive = change >= 0;
  const changeColor = isPositive ? 'text-green-500' : 'text-red-500';

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm">
      <div className="flex gap-1 items-center mb-2">
        {icon && (
          <div className="p-2 text-orange-500 bg-orange-100 rounded-full">
            {icon}
          </div>
        )}
        <h3 className="text-[13px] font-medium text-gray-600">{title}</h3>
      </div>
      
      <div className="flex flex-col gap-3 items-center">
        <span className="text-xl font-semibold text-gray-900">{value}</span>
        <div className="flex gap-1 items-center mb-1">
          <span className={`flex gap-1 items-center text-xs font-medium ${changeColor}`}>
            {isPositive ? <TrendingUp size={16} /> : <TrendingDown size={16} />}
            {isPositive ? `+${change}%` : `${change}%`}
          </span>
          {/* <span className="text-sm text-gray-500">
            {period}
          </span> */}
        </div>
      </div>
    </div>
  )
}

export default MetricCard